import React, { useContext } from "react";
import * as FaIcons from "react-icons/fa";
import RegistrationContext from "../../../context/registration/registrationContext";
import ProgressButtons from "../ProgressButtons";
import SubFormButtons from "../SubFormButtons";
import { useEffect } from "react";
import educationLevels from "../../../data/educationLevels";
import relationshipList from "../../../data/relationshipList";
import phoneTypes from "../../../data/phoneTypes";

// 1
// pgHighestLevelOfEducation - Select List

// 2
// permissionParentContact - Yes/No

// 3
// pgRelationshipToStudent

// 4
// pgFirstName
// pgLastName

// 5
// pgPrimaryPhone
// pgPrimaryPhoneType - Select List

// const Screen1 = () => {
const R33Parent2Information = () => {
  const registrationContext = useContext(RegistrationContext);
  const {
    subFormLevels,
    onFormDataChange,
    pass: { parent2Information },
    // pgPrimaryPhone,
    // pgPrimaryPhoneType,
    formData: {
      pg2HighestLevelOfEducation,
      firstName,
      pg2FirstName,
      pg2LastName,
      pg2RelationshipToStudent,

      pg2PrimaryEmail,
      pg2PrimaryPhone,
      pg2PrimaryPhoneType,
      liveWithPg2,
    },
  } = registrationContext;

  const handleChange = (e) => {
    const value = e.target.value;
    e.target.value =
      value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    onFormDataChange(e);
  };

  const validateEmail = (email) => {
    const reg =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const re =
      /^[^.#]+([a-zA-Z[0-9.!$%&'*+/=?^_`{|}~-]+)[^-#\.]@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))+$/;
    ///^(+(\.[^<>()[a-zA-Z[0-9\]\\.,;:\s@"]+)*)|(".+")@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))+$/;

    return (
      re.test(String(email).toLowerCase()) &&
      reg.test(String(email).toLowerCase())
    );
  };

  const validatePhone1 = (number) => {
    const re = /^\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
    return re.test(String(number).toLowerCase());
  };

  const formatPhoneNumber1 = (evt) => {
    const regex = /^\+?[0-9-]+$/;
    if (evt.target.value === "" || regex.test(evt.target.value)) {
      var aVal = evt.target.value;
      aVal = aVal
        .replace(/\\D/g, "")
        .replace(/ /g, "")
        .replace(/\-/g, "")
        .replace(/\(/g, "")
        .replace(/\)/g, "");
      if (aVal.length >= 10 && aVal.charAt(0) == "1")
        aVal = aVal.replace("-", "").replace("-", "");
      if (aVal.length > 0) {
        if (aVal.length > 8) {
          aVal =
            aVal.substring(0, 3) +
            "-" +
            aVal.substring(3, 6) +
            "-" +
            aVal.substring(6, 10);
          // window.alert(aVal);
          evt.target.value = aVal;
        } else if (aVal.length == 7) {
          aVal = aVal.substring(0, 3) + "-" + aVal.substring(3, 7);
          evt.target.value = aVal;
        }
      }
      onFormDataChange(evt);
    }
  };

  const parents2Info = "";

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
     
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <>
      <div className="sub-form">
        <h2 className="">
          Parent2 Information <span>(4/11)</span>
          <hr />
        </h2>
        <div className="item">
          <div className="asterisk-group">
            <h3>What is {firstName === "" ? "the Student" : firstName}'s Parent 2/Guardian’s Highest Level of Education?</h3>
            {/* <FaIcons.FaAsterisk className="asterisk-icon" /> */}
          </div>
          <select
            name="pg2HighestLevelOfEducation"
            value={pg2HighestLevelOfEducation}
            onChange={(e) => onFormDataChange(e)}
          >
            <option value="">Please Select </option>
            {educationLevels.map((item) => {
              return <option value={item}>{item}</option>;
            })}
          </select>
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>
              What is Parent 2/Guardian’s Relationship to{" "}
              {firstName === "" ? "the Student" : firstName}?{" "}
            </h3>
          </div>
          <select
            name="pg2RelationshipToStudent"
            value={pg2RelationshipToStudent}
            onChange={(e) => onFormDataChange(e)}
          >
            <option value="">Please Select </option>
            {relationshipList.map((item) => {
              return <option value={item}>{item}</option>;
            })}
          </select>
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>What is {firstName === "" ? "the Student" : firstName}'s Parent 2/Guardian’s First Name?</h3>
          </div>
          <input
            type="text"
            name="pg2FirstName"
            maxLength="50"
            onChange={(e) =>  onFormDataChange(e)}
            value={pg2FirstName}
          />
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>What is {firstName === "" ? "the Student" : firstName}'s the Parent 2/Guardian’s Last Name?</h3>
          </div>
          <input
            type="text"
            name="pg2LastName"
            maxLength="50"
            onChange={(e) =>  onFormDataChange(e)}
            value={pg2LastName}
          />
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>What is {firstName === "" ? "the Student" : firstName}'s  Parent 2/Guardian's Primary Phone Number?</h3>
          </div>
          <input
            type="text"
            max="12"
            placeholder="XXX-XXX-XXXX"
            name="pg2PrimaryPhone"
            value={pg2PrimaryPhone}
            onChange={(e) => formatPhoneNumber1(e)}
          />
          {pg2PrimaryPhone !== "" && !validatePhone1(pg2PrimaryPhone) && (
            <p className="validEmail">
              Please provide a valid phone number in the following format
              XXX-XXX-XXXX
            </p>
          )}
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>What is {firstName === "" ? "the Student" : firstName}'s Parent 2/Guardian's Primary Phone Type?</h3>
          </div>
          <select
            name="pg2PrimaryPhoneType"
            value={pg2PrimaryPhoneType}
            onChange={(e) => onFormDataChange(e)}
          >
            <option value="">Please Select </option>
            {phoneTypes.map((item) => {
              return <option value={item}>{item}</option>;
            })}
          </select>
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>What is {firstName === "" ? "the Student" : firstName}'s Parent 2/Guardian’s Email?</h3>
          </div>
          <input
            type="email"
            name="pg2PrimaryEmail"
            value={pg2PrimaryEmail}
            onChange={(e) => onFormDataChange(e)}
          />
          {pg2PrimaryEmail !== "" && !validateEmail(pg2PrimaryEmail) && (
            <p className="validEmail">Please provide a valid email address</p>
          )}
        </div>

      

        <div className="item">
          <div className="asterisk-group">
            <h3>
              Does {firstName === "" ? "the Student" : firstName} Live With
              Parent 2?
            </h3>
          </div>
          <div className="flex-check-container">
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={liveWithPg2["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="liveWithPg"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={liveWithPg2["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="liveWithPg"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
      </div>

      <div className="group">{subFormLevels.parent2Information === 0}</div>
      <ProgressButtons validation={!parents2Info} name="parent2Information" />
    </>
  );
};
export default R33Parent2Information;
